<template>
  <div>
    <!-- 搜索区域 -->
    <div class="searchBox">
      <div class="Search">
        <div class="searchTxt">设备编号</div>
        <el-input
          placeholder="请输入设备编号"
          size="medium"
          v-model="queryMedia.devNo"
          @change="getMedia()"
          clearable
        >
        </el-input>
      </div>
      <div class="Search">
        <div class="searchTxt">人员姓名</div>
        <el-input
          placeholder="请输入人员姓名"
          size="medium"
          v-model="queryMedia.empName"
          @change="getMedia()"
          clearable
        >
        </el-input>
      </div>
      <div class="Search1">
        <div class="searchTxt">拍摄时间</div>
        <el-date-picker
          @input="getMedia()"
          v-model="Time"
          type="datetimerange"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          align="left"
        >
          <!-- value-format="yyyy-MM-dd HH:mm:ss" -->
        </el-date-picker>
      </div>
      <div class="SearchBtn">
        <el-button
          type="primary"
          icon="el-icon-refresh"
          size="mini"
          style="height: 34px"
          @click="reset"
          >重置条件</el-button
        >
      </div>
      <div class="SearchBtn">
        <el-button
          type="primary"
          icon="el-icon-s-operation"
          size="mini"
          style="height: 34px"
          @click="drawerDialog = true"
          >更多筛选</el-button
        >
      </div>
      <div class="SearchBtn">
        <el-button
          type="primary"
          icon="el-icon-s-check"
          size="mini"
          style="height: 34px"
          v-show="deleteFilesBtn"
          @click="TagDialogVisible = true"
          >批量标签</el-button
        >
      </div>
      <div class="SearchBtn">
        <el-button
          type="primary"
          icon="el-icon-s-claim"
          size="mini"
          style="height: 34px"
          v-show="deleteFilesBtn"
          @click="openTaskDialogVisible()"
          >关联任务</el-button
        >
      </div>
      <div class="SearchBtn">
        <el-button
          type="primary"
          icon="el-icon-download"
          size="mini"
          style="height: 34px"
          v-show="deleteFilesBtn"
          @click="downLoadAll()"
          :disabled="this.downLoadAllBtn"
          >批量下载</el-button
        >
      </div>
      <div class="SearchBtn">
        <el-button
          type="danger"
          icon="el-icon-delete"
          size="mini"
          style="height: 34px"
          v-show="deleteFilesBtn"
          @click="deleteFiles()"
          >批量删除</el-button
        >
      </div>
    </div>

    <!-- 卡片区域 -->
    <el-card class="right-card">
      <!-- 文件信息表格区域 -->
      <el-table
        ref="fileTable"
        :data="fileList"
        :header-cell-style="{
          background: '#0395d9',
          color: '#505255',
          textAlign: 'center',
        }"
        :cell-style="{ color: '#4d5a6a', textAlign: 'center' }"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column prop="mediaDevNo" label="设备编号"> </el-table-column>
        <el-table-column prop="mediaEmpName" label="人员姓名">
        </el-table-column>
        <el-table-column prop="mediaDepName" label="项目名称">
        </el-table-column>

        <el-table-column prop="mediaName" label="文件名" min-width="180">
          <template v-slot="mediaNameSlot">
            <el-tooltip class="item" effect="light" placement="bottom">
              <div slot="content" style="max-width: 500px">
                {{ mediaNameSlot.row.mediaName }}
              </div>
              <span class="txtEllipsis">{{
                mediaNameSlot.row.mediaName.split("__")[
                  mediaNameSlot.row.mediaName.split("__").length - 1
                ]
              }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="mediaTaskNumber" label="任务编号">
        </el-table-column>
        <el-table-column prop="mediatagList" min-width="120" label="标签">
          <template v-slot="mediatagListSlot">
            <span v-show="mediatagListSlot.row.mediatagList.length <= 0">
              —
            </span>
            <span
              v-for="mediatag in mediatagListSlot.row.mediatagList"
              :key="mediatag.mtagId"
            >
              <el-tag
                type="info"
                size="small"
                v-if="mediatag.mtagAttribute == 0"
                >{{ mediatag.mtagName }}</el-tag
              >
              <el-tag
                type="danger"
                size="small"
                v-if="mediatag.mtagAttribute == 1"
                >{{ mediatag.mtagName }}</el-tag
              >
              <el-tag
                type="warning"
                size="small"
                v-if="mediatag.mtagAttribute == 2"
                >{{ mediatag.mtagName }}</el-tag
              >
              <el-tag
                type="success"
                size="small"
                v-if="mediatag.mtagAttribute == 3"
                >{{ mediatag.mtagName }}</el-tag
              >
              <el-tag
                type="primary"
                size="small"
                v-if="mediatag.mtagAttribute == 4"
                >{{ mediatag.mtagName }}</el-tag
              >
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="mediaType" width="80" label="文件类型">
          <template v-slot="mediaTypeSlot">
            <span>{{
              mediaTypeSlot.row.mediaType == 1
                ? "视频"
                : mediaTypeSlot.row.mediaType == 2
                ? "音频"
                : mediaTypeSlot.row.mediaType == 3
                ? "图片"
                : mediaTypeSlot.row.mediaType == 4
                ? "文本"
                : "其他"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="mediaLevel" width="50" label="级别">
          <template v-slot="mediaLevelSlot">
            <span>{{
              mediaLevelSlot.row.mediaLevel == 1 ? "重点" : "普通"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="mediaLock" width="80" label="锁定状态">
          <template v-slot="mediaLevelSlot">
            <i
              class="el-icon-unlock"
              v-if="mediaLevelSlot.row.mediaLock == 0"
              style="color: rgb(8, 238, 8); font-size: 25px"
            ></i>
            <i
              class="el-icon-lock"
              v-if="mediaLevelSlot.row.mediaLock == 1"
              style="color: red; font-size: 25px"
            ></i>
          </template>
        </el-table-column>
        <el-table-column prop="mediaCreatetime" min-width="85" label="拍摄时间">
        </el-table-column>
        <el-table-column prop="mediaSize" width="90" label="文件大小">
          <template v-slot="mediaSizeSlot">
            <!-- 如果小于0.1KB转化成B  -->
            <span v-if="mediaSizeSlot.row.mediaSize < 0.1 * 1024"
              >{{ mediaSizeSlot.row.mediaSize.toFixed(2) + "B" }}
            </span>
            <!-- //如果小于0.1MB转化成KB   -->
            <span v-else-if="mediaSizeSlot.row.mediaSize < 0.1 * 1024 * 1024"
              >{{ (mediaSizeSlot.row.mediaSize / 1024).toFixed(2) + "KB" }}
            </span>
            <!-- //如果小于0.1GB转化成MB   -->
            <span
              v-else-if="mediaSizeSlot.row.mediaSize < 0.1 * 1024 * 1024 * 1024"
              >{{
                (mediaSizeSlot.row.mediaSize / (1024 * 1024)).toFixed(2) + "MB"
              }}
            </span>
            <!-- 其他转化成GB    -->
            <span v-else>
              {{
                (mediaSizeSlot.row.mediaSize / (1024 * 1024 * 1024)).toFixed(
                  2
                ) + "GB"
              }}
            </span>
          </template>
        </el-table-column>
        <!-- 文件描述，如需要使用把注释去掉 -->
        <!-- <el-table-column prop="mediaRemark" label="描述">
          <template v-slot="mediaRemarkSlot">
            <el-tooltip
              class="item"
              effect="light"
              placement="bottom"
              v-if="mediaRemarkSlot.row.mediaRemark != null"
            >
              <div slot="content" style="max-width: 500px">
                {{ mediaRemarkSlot.row.mediaRemark }}
              </div>
              <span class="txtEllipsis">
                {{
                  mediaRemarkSlot.row.mediaRemark == null
                    ? "-"
                    : mediaRemarkSlot.row.mediaRemark
                }}</span
              >
            </el-tooltip>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" width="130">
          <template v-slot="slot">
            <el-tooltip
              class="item"
              effect="dark"
              content="播放"
              placement="bottom-start"
            >
              <i
                class="el-icon-video-play"
                style="
                  font-size: 20px;
                  color: rgb(53, 198, 224);
                  cursor: pointer;
                "
                @click="play(slot.row)"
              ></i>
            </el-tooltip>
            <el-divider direction="vertical"></el-divider>
            <el-tooltip
              class="item"
              effect="dark"
              content="下载"
              placement="bottom-start"
            >
              <i
                class="el-icon-download"
                style="
                  font-size: 20px;
                  color: rgb(107, 236, 28);
                  cursor: pointer;
                "
                @click="downloadFile(slot.row.mediaServerPath)"
              ></i>
            </el-tooltip>
            <el-divider direction="vertical"></el-divider>
            <el-tooltip
              class="item"
              content="删除"
              placement="bottom-start"
              effect="dark"
            >
              <i
                class="el-icon-delete"
                style="font-size: 20px; color: red"
                @click="deleteFile(slot.row.mediaId)"
              ></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="queryMedia.page"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="queryMedia.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      >
      </el-pagination>
    </el-card>
    <!-- 更多筛查抽屉对话框 -->
    <el-drawer
      title="更多筛查"
      :visible.sync="drawerDialog"
      direction="rtl"
      custom-class="demo-drawer"
      ref="drawer"
      size="300px"
    >
      <div class="demo-drawer__content">
        <div class="searchDrawer">
          <div class="Search">
            <div class="searchTxt">人员编号</div>
            <el-input
              placeholder="请输入人员编号"
              size="medium"
              v-model="queryMedia.empNo"
              @change="getMedia()"
              clearable
            >
            </el-input>
          </div>
          <div class="Search">
            <div class="searchTxt">任务编号</div>
            <el-input
              placeholder="请输入任务编号"
              size="medium"
              v-model="queryMedia.taskNumber"
              @change="getMedia()"
              clearable
            >
            </el-input>
          </div>
          <div class="Search">
            <div class="searchTxt">项目名称</div>
            <el-select
              v-model="queryMedia.depId"
              placeholder="请选择"
              ref="MySelect"
              clearable
              @clear="cleardepId()"
              @focus="GetAllDepTrees()"
            >
              <el-option
                :key="queryMedia.depId"
                :label="checkDname"
                :value="queryMedia.depId"
                style="height: auto"
              >
              </el-option>
              <el-tree
                style="height: 300px"
                :data="depTrees"
                :props="defaultTreesProps"
                :expand-on-click-node="false"
                :highlight-current="true"
                @node-click="handleNodeClick2"
              >
              </el-tree>
            </el-select>
          </div>
          <div class="Search">
            <div class="searchTxt">文件类型</div>
            <el-select
              v-model="queryMedia.mediaType"
              @change="getMedia()"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in mediaTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="Search">
            <div class="searchTxt">文件级别</div>
            <el-select
              v-model="queryMedia.mediaLevel"
              @change="getMedia()"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in mediaLevelOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </el-drawer>
    <!-- 播放对话框 -->
    <el-dialog
      :title="'文件播放:' + this.updateMediaInfo.mediaName"
      :visible.sync="PlayDialogVisible"
      width="60%"
      :close-on-click-modal="false"
      @close="clearPlayDialogVisible()"
    >
      <div class="playBox">
        <div style="width: 800px; height: 500px">
          <el-image
            style="height: 500px; width: 100%"
            v-if="this.updateMediaInfo.mediaType == 3"
            :src="this.updateMediaInfo.mediaServerPath"
            :preview-src-list="[this.updateMediaInfo.mediaServerPath]"
          >
          </el-image>
          <easy-player
            v-if="
              this.updateMediaInfo.mediaType == 1 ||
              this.updateMediaInfo.mediaType == 2
            "
            fluent
            alt="无视频"
            :muted="false"
            loop
            autoplay
            isH265
            playbackRates="false"
            :video-url="this.updateMediaInfo.mediaServerPath"
          >
          </easy-player>
          <el-alert v-if="this.updateMediaInfo.mediaType == 4" title="请下载后查看!" center  :closable="false" type="warning" show-icon> </el-alert>
        </div>

        <!-- 表单区域 -->
        <el-form ref="PlayFormRef" :model="updateMediaInfo" label-width="80px">
          <el-form-item label="人员姓名">
            <el-input v-model="updateMediaInfo.mediaEmpName" :disabled="true">
            </el-input>
          </el-form-item>
          <el-form-item label="设备编号">
            <el-input :disabled="true" v-model="updateMediaInfo.mediaDevNo">
            </el-input>
          </el-form-item>
          <el-form-item label="文件标签">
            <el-select
              ref="myTagSelect"
              v-model="updateMediaInfo.mtagIds"
              multiple
              filterable
              placeholder="请选择"
            >
              <!-- @visible-change="getTag" -->
              <el-option
                v-for="item in roleList"
                :key="item.mtagId"
                :label="item.mtagName"
                :value="item.mtagId"
              >
              </el-option>
            </el-select>
            <!-- <div v-if="value1.length > 0">
              <el-tag
                v-for="value in value1"
                :key="value"
                :type="getTagColor(value)"
              >
                {{ value }}
              </el-tag>
            </div> -->
          </el-form-item>
          <el-form-item label="重点标记">
            <el-radio-group v-model="updateMediaInfo.mediaLevel">
              <el-radio :label="0">普通</el-radio>
              <el-radio :label="1">重点</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="锁定状态">
            <el-radio-group v-model="updateMediaInfo.mediaLock">
              <el-radio :label="0">未锁</el-radio>
              <el-radio :label="1">锁定</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="文件描述">
            <el-input
              type="textarea"
              v-model="updateMediaInfo.mediaRemark"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="PlayDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="Update()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 批量文件关联标签对话框 -->
    <el-dialog
      title="批量文件关联标签"
      :visible.sync="TagDialogVisible"
      width="60%"
      :close-on-click-modal="false"
      @close="clearTagsDialogVisible()"
    >
      <div>
        <!-- 表单区域 -->
        <el-form ref="PlayFormRef" label-width="80px">
          <el-form-item label="文件标签">
            <el-select
              v-model="batchAddmTagIds"
              multiple
              filterable
              placeholder="请选择"
              @visible-change="getTag"
            >
              <el-option
                v-for="item in roleList"
                :key="item.mtagId"
                :label="item.mtagName"
                :value="item.mtagId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="TagDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchAddMediatag()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 批量文件关联任务对话框 -->
    <el-dialog
      title="批量文件关联任务"
      :visible.sync="taskDialogVisible"
      width="60%"
      :close-on-click-modal="false"
      @close="clearTaskDialogVisible()"
    >
      <div>
        <!-- 搜索区域 -->
        <div
          style="
            display: flex;
            color: #0693c0;
            font-weight: 900;
            margin-bottom: 10px;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              justify-items: center;
              margin-right: 10px;
            "
          >
            <div style="width: 100px">任务编号：</div>
            <el-input
              placeholder="请输入任务编号"
              size="medium"
              v-model="TaskqueryInfo.taskNumber"
              @change="getTask()"
              clearable
            >
            </el-input>
          </div>
          <div
            style="display: flex; align-items: center; justify-items: center"
          >
            <div style="width: 100px">任务标题：</div>
            <el-input
              placeholder="请输入任务标题"
              size="medium"
              v-model="TaskqueryInfo.taskTitle"
              @change="getTask()"
              clearable
            >
            </el-input>
          </div>
        </div>
        <el-table
          :data="taskList"
          max-height="400px"
          :header-cell-style="{
            background: '#0395d9',
            color: '#505255',
            textAlign: 'center',
          }"
          :cell-style="{ color: '#4d5a6a', textAlign: 'center' }"
          :header-cell-class-name="headerCellStyle"
          @select="selectChange"
          @selection-change="taskHandleSelectionChange"
          ref="TaskTable"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="taskNumber" label="任务编号">
          </el-table-column>
          <el-table-column prop="taskTitle" label="任务标题"> </el-table-column>
          <el-table-column prop="taskContent" label="任务内容">
            <template v-slot="taskContentSlot">
              <el-tooltip class="item" effect="light" placement="bottom">
                <div slot="content" style="max-width: 500px">
                  {{ taskContentSlot.row.taskContent }}
                </div>
                <span class="txtEllipsis">{{
                  taskContentSlot.row.taskContent
                }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="taskCreateTime" label="创建时间">
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          @size-change="taskHandleSizeChange"
          @current-change="taskHandleCurrentChange"
          :current-page.sync="TaskqueryInfo.page"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="TaskqueryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="taskTotal"
          background
        >
        </el-pagination>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="taskDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchAddMediaTask()"
          >关联任务</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 播放器
import EasyPlayer from "@easydarwin/easyplayer";
// 文件批量打包下载
import JSZip from "jszip";
import FileSaver from "file-saver";

export default {
  data() {
    return {
      // 文件信息
      fileList: [],
      // 总数量
      total: 0,
      // 查询文件信息
      queryMedia: {
        // 文件名
        mediaName: "",
        // 文件类型
        mediaType: "",
        // 开始时间
        bTime: "",
        //结束时间
        eTime: "",
        // 设备编号
        devNo: "",
        // 人员编号
        empNo: "",
        // 人员姓名
        empName: "",
        // 任务编号
        taskNumber: "",
        // 单位ID
        depId: "",
        // 文件登记查询
        mediaLevel: "",
        //  当前页
        page: 1,
        //  每页显示多少条
        pageSize: 10,
      },

      // 更多查询抽屉对话框
      drawerDialog: false,
      // 单位树信息
      depTrees: [],
      defaultTreesProps: {
        children: "depChilds",
        label: "depName",
      },
      // 增加单位选中单位名称
      checkDname: "",
      //文件类型
      mediaTypeOptions: [
        {
          value: 1,
          label: "视频",
        },
        {
          value: 2,
          label: "音频",
        },
        {
          value: 3,
          label: "图片",
        },
        {
          value: 4,
          label: "文本",
        },
      ],
      //文件级别
      mediaLevelOptions: [
        {
          value: 0,
          label: "普通",
        },
        {
          value: 1,
          label: "重要",
        },
      ],
      // 时间选择器选择的开始和结束时间
      Time: "",
      // 时间选择器
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },

      // 打开视频播放对话框
      PlayDialogVisible: false,
      // 修改视频内容
      updateMediaInfo: {
        mediaLevel: "", //重点标记
        mediaLock: "", //文件状态：0未锁定; 1锁定
        mediaRemark: "", //文件备注
        mtagIds: [], //标签id
        mediaEmpName: "", //人员姓名
        mediaDevNo: "", //设备编号
        mediaName: "", //文件名称
      },
      // 删除单个文件ID
      mediaId: [],
      // 删除多个文件ID
      mediaIds: [],
      // 控制批量删除按钮显示与隐藏
      deleteFilesBtn: false,
      // 标签信息
      roleList: [],
      // 查询标签信息
      queryTag: {
        // 标签名称
        mtagName: "",
        //  当前页
        page: 1,
        //  每页显示多少条(这里现在默认这么多数据，后面如果加载慢，就需要写分页)
        pageSize: 9999,
      },
      // 批量关联标签对话框
      TagDialogVisible: false,
      // 批量关联标签
      batchAddmTagIds: [],
      //批量关联任务对话框
      taskDialogVisible: false,
      // 任务列表
      taskList: [],
      // 任务总数量
      taskTotal: 0,
      // 任务列表查询信息
      TaskqueryInfo: {
        // 任务编号
        taskNumber: "",
        // 任务标题
        taskTitle: "",
        //  当前页
        page: 1,
        //  每页显示多少条
        pageSize: 10,
      },
      // 任务ID
      taskId: "",
      //批量下载文件地址
      mediaServerPaths: [],
      // 批量下载按钮禁用开启状态
      downLoadAllBtn: false,
    };
  },
  components: {
    EasyPlayer,
  },
  computed: {},

  mounted() {
    this.getMedia();
    // 获取单位树
    // this.GetAllDepTrees();
  },
  methods: {
    getTagColor(value) {
      switch (value) {
        case "0":
          return "success";
        case "1":
          return "warning";
        case "2":
          return "danger";
        // 添加其他情况的颜色...
        default:
          return "info"; // 默认值
      }
    },

    // 获取文件信息
    async getMedia() {
      this.queryMedia.bTime = "";
      this.queryMedia.eTime = "";
      if (this.Time) {
        // 开始时间
        this.queryMedia.bTime = this.Time[0];
        // 结束时间
        this.queryMedia.eTime = this.Time[1];
      }
      const { data: res } = await this.$axios.post(
        `${this.$api}/media/search`,
        this.qs.stringify(this.queryMedia)
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      if (res.data.rows) {
        this.fileList = res.data.rows;
        this.total = res.data.total;
      }
    },

    // 获取全部单位树
    async GetAllDepTrees() {
      const { data: res } = await this.$axios.get(
        `${this.$api}/department/getDepTree`
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.depTrees = res.data;
    },

    // 当选中单位时触发
    handleNodeClick2(data) {
      this.queryMedia.depId = data.depId;
      this.checkDname = data.depName;
      this.getMedia();
      // 选择器执行完成后，使其失去焦点隐藏下拉框的效果
      this.$refs.MySelect.handleClose();
    },
    //清空单位id
    cleardepId() {
      this.queryMedia.depId = "";
      this.checkDname = "";
      this.getMedia();
    },
    // 重置查询参数
    reset() {
      this.queryMedia = {
        //  当前页
        page: 1,
        //  每页显示多少条
        pageSize: 10,
      };
      this.Time = "";
      this.checkDname = "";
      this.getMedia();
    },

    // 当每页显示条发生改变时触发
    handleSizeChange(size) {
      this.queryMedia.pageSize = size;
      this.getMedia();
    },
    // 当当前页发生改变时触发
    handleCurrentChange(current) {
      this.queryMedia.page = current;
      this.getMedia();
    },
    // 播放
    play(value) {
      this.getTag();

      // 文件标签
      for (let i = 0; i < value.mediatagList.length; i++) {
        this.updateMediaInfo.mtagIds.push(value.mediatagList[i].mtagId);
      }
      //  文件类型
      this.updateMediaInfo.mediaType = value.mediaType;
      // 文件ID
      this.updateMediaInfo.mediaId = value.mediaId;
      // 文件名
      this.updateMediaInfo.mediaName = value.mediaName;
      // 人员名称
      this.updateMediaInfo.mediaEmpName = value.mediaEmpName;
      // 设备编号
      this.updateMediaInfo.mediaDevNo = value.mediaDevNo;
      // 重要等级
      this.updateMediaInfo.mediaLevel = value.mediaLevel;
      // 锁定状态
      this.updateMediaInfo.mediaLock = value.mediaLock;
      // 描述
      this.updateMediaInfo.mediaRemark = value.mediaRemark;
      // 文件播放地址
      this.updateMediaInfo.mediaServerPath = value.mediaServerPath;
    

      // 打开播放对话框
      this.PlayDialogVisible = true;
    },

    // 修改文件信息
    async Update() {
      // console.log(this.updateMediaInfo.mtagIds);
      const { data: res } = await this.$axios.put(
        `${this.$api}/media/modfiy/${this.updateMediaInfo.mediaId}`,
        {
          mediaLevel: this.updateMediaInfo.mediaLevel,
          mediaLock: this.updateMediaInfo.mediaLock,
          mediaRemark: this.updateMediaInfo.mediaRemark,
          mtagIds: this.updateMediaInfo.mtagIds,
        }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.$message.success("更新文件信息成功");
      this.getMedia();
      this.PlayDialogVisible = false;
    },

    // 获取标签信息
    async getTag() {
      const { data: res } = await this.$axios.get(
        `${this.$api}/media/tag/search`,
        {
          params: this.queryTag,
        }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.roleList = res.data.rows;
      // this.total = res.data.total;
    },

    // 批量文件关联标签
    async batchAddMediatag() {
      const { data: res } = await this.$axios.post(
        `${this.$api}/media/batchAddMediatag`,
        {
          // 文件ID
          mediaIds: this.mediaIds,
          // 标签id
          tagIds: this.batchAddmTagIds,
        }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.$message.success("文件关联标签成功");
      this.getMedia();
      this.TagDialogVisible = false;
    },
    // 关闭文件对话框后的操作
    clearPlayDialogVisible() {
      this.updateMediaInfo.mediaLevel = "";
      this.updateMediaInfo.mediaLock = "";
      this.updateMediaInfo.mediaRemark = "";
      this.updateMediaInfo.mtagIds = [];
      this.updateMediaInfo.mediaServerPath = "";
    },
    // 关闭文件批量关联标签对话框后的操作
    clearTagsDialogVisible() {
      this.batchAddmTagIds = [];
      this.mediaIds = [];
    },

    // 打开关联任务对话框
    openTaskDialogVisible() {
      this.taskDialogVisible = true;
      this.getTask();
    },

    // 查询任务列表信息
    async getTask() {
      const { data: res } = await this.$axios.get(`${this.$api}/task/search`, {
        params: this.TaskqueryInfo,
      });
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      if (res.data) {
        this.taskList = res.data.rows;
        // 任务总数量
        this.taskTotal = res.data.total;
      }
    },

    // 任务当每页显示条发生改变时触发
    taskHandleSizeChange(size) {
      this.TaskqueryInfo.pageSize = size;
      this.getTask();
    },
    // 任务当前页发生改变时触发
    taskHandleCurrentChange(current) {
      this.TaskqueryInfo.page = current;
      this.getTask();
    },

    // 将table表格设置成单选
    headerCellStyle({ column, columnIndex }) {
      if (columnIndex === 0) {
        return "hiddenCheck";
      }
    },

    // 改为单选，即通过Array.shift()方法删除第一条数据并返回新数组，这样就可以把select 事件中的以获取的数组给删掉，同时通过toggleRowSelection方法将删掉的这一行选择状态设置为未选择。
    selectChange(selection) {
      if (selection.length > 1) {
        const del_row = selection.shift();
        this.$refs.TaskTable.toggleRowSelection(del_row, false);
      }
    },
    // 获取table选中的任务信息
    taskHandleSelectionChange(val) {
      if (val.length > 0) {
        this.taskId = val[0].taskId;
        // console.log(this.sendFenceToDevicesInfo.fenceId);
      } else {
      }
    },
    // 批量文件关联任务
    async batchAddMediaTask() {
      const { data: res } = await this.$axios.post(
        `${this.$api}/media/batchRelevanceTask`,
        {
          // 文件ID
          mediaIds: this.mediaIds,
          // 标签id
          taskId: this.taskId,
        }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.$message.success("文件关联任务成功");
      this.getMedia();
      this.taskDialogVisible = false;
    },
    // 关闭文件批量关联任务对话框后的操作
    clearTaskDialogVisible() {
      this.taskId = "";
      this.mediaIds = [];
    },
    // 单文件下载
    downloadFile(mediaServerPath) {
      const link = document.createElement("a");
      link.href = `${mediaServerPath}?download=1`;
      // link.download = "filename.xls";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    // 批量文件点击下载
    downLoadAll() {
      this.downLoadAllBtn = true;
      var date = new Date();
      var year = date.getFullYear(); //获取年份
      var month = date.getMonth() + 1; //获取月份
      var day = date.getDate(); //获取日期
      var hours = date.getHours(); //获取小时
      var minutes = date.getMinutes(); //获取分钟
      var seconds = date.getSeconds(); //获取秒钟
      var now =
        year +
        "年" +
        month +
        "月" +
        day +
        "日 " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;
      var blogTitle = now; // 下载后压缩包的命名
      var zip = new JSZip();
      var promises = [];
      let cache = {};
      let arrImg = [];
      for (let i = 0; i < this.mediaServerPaths.length; i++) {
        arrImg.push({
          path: this.mediaServerPaths[i], // 文件链接
          name: this.mediaServerPaths[i].split("/").pop(), // 文件名称
        });
      }
      for (let item of arrImg) {
        // item.path为文件链接地址
        const promise = this.getImgArrayBuffer(item.path).then((data) => {
          // 下载文件, 并存成ArrayBuffer对象(blob)
          zip.file(item.name, data, { binary: true }); // 逐个添加文件
          cache[item.name] = data;
        });
        promises.push(promise);
      }
      Promise.all(promises)
        .then(() => {
          zip.generateAsync({ type: "blob" }).then((content) => {
            // 生成二进制流
            FileSaver.saveAs(content, blogTitle); // 利用file-saver保存文件  自定义文件名
            this.downLoadAllBtn = false;
            this.$refs.fileTable.clearSelection(); //清空表格选择
          });
        })
        .catch((res) => {
          alert("文件压缩失败");
          this.downLoadAllBtn = false;
        });
    },
    //文件以流的形式获取（参数url为文件链接地址）
    getImgArrayBuffer(url) {
      return new Promise((resolve, reject) => {
        //通过请求获取文件blob格式
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.open("GET", url, true);
        xmlhttp.responseType = "blob";
        xmlhttp.onload = function () {
          if (this.status == 200) {
            resolve(this.response);
          } else {
            reject(this.status);
          }
        };
        xmlhttp.send();
      });
    },

    // 删除单个文件
    async deleteFile(mediaId) {
      this.mediaId = [];
      this.mediaId.push(mediaId);
      const confirmVal = await this.$confirm(
        "此操作将永久删除该文件, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmVal != "confirm") {
        return this.$message.info("已取消删除");
      }
      const { data: res } = await this.$axios.delete(
        `${this.$api}/media/delete`,
        { params: { mediaIds: this.mediaId } }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      // 解决element分页删除最后一页的最后一条数据以后不会跳转到前一页
      // 解决思路：判断被删除的数据是否为最后一页的最后一条数据、如果是则让页码减一，如果不是则在当前面即可
      // math.ceil向上取整
      let lastPage = Math.ceil(this.total / this.queryMedia.pageSize); //总数除以每页记录数
      // 判断当前页是否是最后一页 且 为最后一条数据
      if (
        this.queryMedia.page === lastPage &&
        this.total % this.queryMedia.pageSize === 1
      ) {
        this.queryMedia.page--; //页码-1
      }

      this.$message.success("文件删除成功");
      this.getMedia();
    },

    // 获取table选中的文件信息
    handleSelectionChange(val) {
      if (val.length > 0) {
        this.deleteFilesBtn = true;
      } else {
        this.deleteFilesBtn = false;
      }
      var mediaIds = [];
      for (let i = 0; i < val.length; i++) {
        mediaIds.push(val[i].mediaId);
      }
      this.mediaIds = mediaIds;
      // 获取选择的文件下载路径
      var mediaServerPath = [];
      for (let j = 0; j < val.length; j++) {
        mediaServerPath.push(val[j].mediaServerPath);
      }
      this.mediaServerPaths = mediaServerPath;
    },

    // 删除多个文件
    async deleteFiles() {
      const confirmVal = await this.$confirm(
        "此操作将永久删除该文件, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmVal != "confirm") {
        return this.$message.info("已取消删除");
      }
      const { data: res } = await this.$axios.delete(
        `${this.$api}/media/delete`,
        { params: { mediaIds: this.mediaIds } }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      // 解决element分页删除最后一页的最后一条数据以后不会跳转到前一页
      // 解决思路：判断被删除的数据是否为最后一页的最后一条数据、如果是则让页码减一，如果不是则在当前面即可
      // math.ceil向上取整
      let lastPage = Math.ceil(this.total / this.queryMedia.pageSize); //总数除以每页记录数
      // 判断当前页是否是最后一页 且 为最后一条数据
      if (
        this.queryMedia.page === lastPage &&
        this.total % this.queryMedia.pageSize === 1
      ) {
        this.queryMedia.page--; //页码-1
      }

      this.$message.success("文件删除成功");
      this.getMedia();
    },
  },
};
</script>


<style lang="less" scoped>
/* 新增按钮 */
.add-btn {
  float: left;
  margin-bottom: 10px;
}

.el-select {
  width: 100%;
}

.box-card {
  height: 400px !important;
  overflow: auto;
  margin: 0;
}

// el-dialog高度自适应，内容超出时中间出现滚动条
.common-dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
  .el-dialog {
    margin: 0 auto !important;
    position: relative;
    .el-dialog__header {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      width: 100%;
      height: 60px;
      z-index: 1;
    }
    .el-dialog__body {
      width: 100%;
      overflow: hidden;
      overflow-y: auto;
      max-height: 90vh; //最大高度为视口高度的90%
      padding-top: 80px;
      padding-bottom: 100px;
      z-index: 1;
    }
    .el-dialog__footer {
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 80px;
      z-index: 1;
    }
  }
}

.searchDrawer {
  border-top: 1px solid #0693c0;
  margin: 0 0 5px 0;
  height: 50px;
  width: 100%;
  display: flex;
  flex-direction: column;

  // 用户名搜索区域
  .Search {
    width: 250px;
    display: flex;
    align-items: center;
    margin-left: 20px;

    // 搜索标题
    .searchTxt {
      color: #0693c0;
      font-weight: bold;
      width: 100px;
    }
    /* element-input背景颜色改为透明，修改输入字体颜色 */
    /deep/ .el-input__inner {
      background-color: transparent;
      color: #0693c0;
      margin: 15px 0;
      border: 1px solid #0693c0;
    }
  }
}

.searchBox {
  border-bottom: 1px solid #0693c0;
  margin: 0 0 5px 0;
  height: 50px;
  width: 100%;
  display: flex;
  align-content: center;

  // 用户名搜索区域
  .Search {
    width: 250px;
    display: flex;
    align-items: center;
    margin-left: 20px;

    // 搜索标题
    .searchTxt {
      color: #0693c0;
      font-weight: bold;
      width: 100px;
    }
    /* element-input背景颜色改为透明，修改输入字体颜色 */
    /deep/ .el-input__inner {
      background-color: transparent;
      color: #0693c0;
      margin: 15px 0;
      border: 1px solid #0693c0;
    }
  }
  .Search1 {
    width: 450px;
    display: flex;
    align-items: center;
    margin-left: 30px;
    // 搜索标题
    .searchTxt {
      color: #0693c0;
      font-weight: bold;
      width: 80px;
    }
    /* element-input背景颜色改为透明，修改输入字体颜色 */
    /deep/ .el-input__inner {
      background-color: transparent;
      color: #0693c0;
      margin: 15px 0;
      border: 1px solid #0693c0;
    }
  }

  .SearchBtn {
    width: 85px;
    display: flex;
    align-items: center;
    margin: 0 10px;
  }
}

// 播放对话框区域
.playBox {
  display: flex;
  justify-content: center;
}
// 单选按钮
.el-radio {
  color: #90caca;
}

// 超出宽度用...代替
.txtEllipsis {
  -webkit-line-clamp: 1; /* 显示的行数 */
  display: -webkit-box; /*必须结合的属性,将对象作为弹性伸缩盒子模型显示*/
  -webkit-box-orient: vertical; /*必须结合的属性,设置或检索伸缩盒对象的子元素的排列方式*/
  overflow: hidden; /*文本会被修剪，并且剩余的部分不可见*/
  text-overflow: ellipsis; /*显示省略号来代表被修剪的文本*/
  // direction: rtl;/* 从右向左显示 */
}

// 重新设置其样式将该”全选框“隐藏掉。
/deep/.hiddenCheck {
  visibility: hidden;
}
/deep/.el-table__header-wrapper {
  background: #0395d9 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/EvidenceCenter/fileView.vue